const routes = [
    {
        path: '/area_cliente_adm',
        alias: ['/area_cliente_adm/inicio', '/area_cliente_adm/sistema/inicio'],
        component: () => import('../views/Inicio')
    }
]

export default routes